export default "__VITE_ASSET__DI3YD_UT__"